module.exports = __webpack_public_path__ + "img/bb_g3_ears-04.21070755.svg";